
import { Box } from '@mui/material';
import Heading from '../../text/Heading';
import Text from '../../text/Text';
import { ReactComponent as TableEmpty } from '../../../../styles/svg/tableempty.svg'
import { useTranslation } from 'react-i18next';

const ShGridEmpty = ({ titleKey = 'grid_empty_title', descriptionKey = 'grid_empty_description' }) => {
    const {t} = useTranslation();

    return (
        <Box
            sx={{
                display:"flex",
                justifyContent:"center",
            }}
        >
            <Box
                sx={{
                    maxWidth:300,
                    display:"flex",
                    justifyContent:"center",
                    flexDirection:"column",
                    alignItems:"center"
                }}
            >
                <TableEmpty/>
                <Box
                    sx={{
                        mt:3,
                        display:"flex",
                        flexDirection:"column",
                        gap:0.5
                    }}
                >
                    <Heading align="center">{t(titleKey)}</Heading>
                    <Text align="center" light>{t(descriptionKey)}</Text>
                </Box>
            </Box>
        </Box>
    );
}

export default ShGridEmpty;